import React, {Component} from 'react';
import {connect} from "react-redux";
import {Input, List} from "semantic-ui-react";

class TextField extends Component {

    componentDidMount() {
        this.elRef.scrollIntoView({ behavior: "smooth" });
    }

    render() {
        const showErrors = typeof this.props.showErrors !== "undefined" ? this.props.showErrors : true;
        return <div style={this.props.noMargin ? {margin: 0} : {margin: "0 0 1rem 0"}} ref={(el) => { this.elRef = el; }}>
            <Input
                fluid
                type={this.props.type}
                icon={this.props.icon}
                iconPosition={this.props.iconPosition}
                placeholder={this.props.placeholder}
                disabled={this.props.disabled}
                value={this.props.value}
                error={showErrors && typeof this.props.errors !== "undefined" && this.props.errors.length > 0}
                onChange={this.props.onChange}/>
            {showErrors && typeof this.props.errors !== "undefined" && <List style={{color: "#9f3a38", margin: ".28571429rem 0 0 0"}}>
                {this.props.errors.map((error, index) => <List.Item key={index}>{error}</List.Item>)}
            </List>}
        </div>
    }
}


function mapStateToProps(state) {
    return {}
}

export default connect(mapStateToProps)(TextField);


// WEBPACK FOOTER //
// ./src/components/common/TextField.js